import z from 'zod';

export const $CandidatePrivateDataEditSchema = z.object({
  lastName: z.string().nullable(),
  firstName: z.string().nullable(),
  phone: z.string().min(1, 'Телефон обязателен'),
  preferredCommunicationLanguage: z.string().nullable(),
  allCities: z.boolean(),
  cityIds: z.array(z.number()),
  educationLevelId: z.string().nullable(),
  professionName: z
    .string()
    .max(255, 'Специальность не должна превышать 255 символов')
    .nullable(),
  generalInfo: z.string().nullable(),
});
